import type * as React from 'react';
import { get } from '@Domain/Api';
import aiTranscriptionDeliveryModesFetched, {
	type AiTranscriptionDeliveryModesFetchedAction,
	type AiTranscriptionDeliveryModesFetchedPayload,
} from '@Application/Ai/AiTranscriptionDeliveryModes/Actions/aiTranscriptionDeliveryModesFetched';
import aiTranscriptionDeliveryModesFetchFailed, {
	type AiTranscriptionDeliveryModesFetchFailedAction,
} from '@Application/Ai/AiTranscriptionDeliveryModes/Actions/aiTranscriptionDeliveryModesFetchFailed';
import type FetchAiTranscriptionDeliveryModes from '@Application/Ai/AiTranscriptionDeliveryModes/Queries/FetchAiTranscriptionDeliveryModes';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiTranscriptionDeliveryModesFetchedAction | AiTranscriptionDeliveryModesFetchFailedAction;

export default (_query: FetchAiTranscriptionDeliveryModes) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiTranscriptionDeliveryModesFetchedPayload>(
				`${parameters.api.host}/api/enums/ai-transcription-delivery-modes`,
			);

			const action = aiTranscriptionDeliveryModesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiTranscriptionDeliveryModesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
